import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {UserPersistRequest} from "../model/requests/user-persist-request";
import {UserFilters} from '../model/filters/user-filters';
import {User} from "../model/user";
import {UserGroupsPersistRequest} from "../model/requests/user-groups-persist-request";
import {FiltersUtils} from "../shared/filters.utils";

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private readonly userURL: string;


  constructor(private http: HttpClient) {
    this.userURL = '/api/users';
  }

  public getUsers(offset?: number, limit?: number, filters?: UserFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    if (filters != null) {
      options.params["firstName"] = FiltersUtils.getFilterTrim(filters.firstName);
      options.params["lastName"] = FiltersUtils.getFilterTrim(filters.lastName);
      options.params["username"] = FiltersUtils.getFilterTrim(filters.username);
      options.params["profileUuids"] = FiltersUtils.getFilter(filters.profileUuids);
      options.params["email"] = FiltersUtils.getFilterTrim(filters.email);
      options.params["phone"] = FiltersUtils.getFilterTrim(filters.phone);
      options.params["userType"] = FiltersUtils.getFilter(filters.userType);
      options.params["organizationUuids"] = FiltersUtils.getFilter(filters.organizationUuids);
    }
    return this.http.get<any>(this.userURL, options);
  }

  public getUser(userUuid: string): Observable<{ user: User }> {
    const url: string = `${this.userURL}/${userUuid}`;
    return this.http.get<{ user: User }>(url);
  }

  public getUserSummary(userUuid: string): Observable<{ user: User }> {
    const url: string = `${this.userURL}/summary/${userUuid}`;
    return this.http.get<{ user: User }>(url);
  }

  public createUser(userData: UserPersistRequest): Observable<any> {
    return this.http.post<any>(this.userURL, userData);
  }

  public editUser(userData: UserPersistRequest): Observable<any> {
    const url: string = `${this.userURL}/${userData.uuid}`;
    return this.http.put<any>(url, userData);
  }

  public deleteUser(userUuid: string): Observable<HttpResponse<any>> {
    const url: string = `${this.userURL}/${userUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteUsers(uuids: { uuid: string }[]): Observable<HttpResponse<any>> {
    const url: string = `${this.userURL}/delete`;
    return this.http.post<any>(url, uuids, {observe: 'response'});
  }

  public assignUserToGroups(userGroupsData: UserGroupsPersistRequest): Observable<any> {
    const url: string = `${this.userURL}/groups/${userGroupsData.uuid}`;
    return this.http.put<any>(url, userGroupsData);
  }

}
